import {
  SET_SHOW_CHARTS_ACT,
  SET_DATE_ACT,
  SET_CENTRO_CUSTO_ACTION,
  SET_EMPRESA_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_RESPONSAVEL_ACTION,
} from './actions.type';
import {
  SET_SHOW_CHARTS,
  SET_DATE,
  SET_CENTRO_CUSTO,
  SET_EMPRESA,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
} from './mutations.type';

export default {
  [SET_SHOW_CHARTS_ACT](context, data) {
    context.commit(SET_SHOW_CHARTS, data);
  },
  [SET_DATE_ACT](context, dateSelection) {
    context.commit(SET_DATE, dateSelection);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_CENTRO_CUSTO_ACTION](context, centroCusto) {
    context.commit(SET_CENTRO_CUSTO, centroCusto);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_RESPONSAVEL_ACTION](context, responsavel) {
    context.commit(SET_RESPONSAVEL, responsavel);
  },
};
